import { checkIsInternalCompany } from 'app/auth/authUtils';

export const checkIsHeaderViewGlobal = headerView =>
  checkIsInternalCompany({ companyId: headerView?.companyId });

// The write endpoints resolve a header view through the caller's own tenant, so anything a
// company does not own is read-only for it — global templates for a tenant, and equally a
// tenant's view for a Skynet-internal user.
export const checkIsHeaderViewOwned = (headerView, masterCompanyId) =>
  !!masterCompanyId && headerView?.companyId === masterCompanyId;

// GlobalityLabelCDS renders "Local" for false and nothing only for a non-boolean, so an owned
// view must resolve to undefined. Collapsing this to a boolean puts the Local chip back.
export const resolveHeaderViewGlobality = (headerView, isInternalCompany) =>
  !isInternalCompany && checkIsHeaderViewGlobal(headerView) ? true : undefined;
